import React, { Component } from 'react';
import Modal from '../../../components/modals';
import Select, { components } from 'react-select';
import { gql } from '@apollo/client';
import _, { functions } from 'lodash';
import { toast } from 'react-toastify';
import ProjectsGraphQl from '../../../../controllers/projectsGraphQl';
import InputHeader from '../../global/inputwithHeader';
import service from '../../../../services/graphQlServices';
import LoadingBar from '../../../components/global/loadingBar';
import Dropzone from 'react-dropzone';
import { ReactComponent as MoreVerticalIcon } from '../../../../assets/svg/Project/more-vertical.svg';
import { ReactComponent as AttachIcon } from '../../../../assets/svg/attachment.svg';
import { ReactComponent as DownIcon } from '../../../../assets/svg/arrow-ios-downward.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/svg/trash3.svg';
import { ReactComponent as CheckedIcon } from '../../../../assets/svg/check-selected.svg';

import { Document, Page, pdfjs } from 'react-pdf';
import moment from 'moment';
import { withRouter } from '../../../../services/withRoute';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
var randomize = require('randomatic');

const getVendorInfo = gql`
	query VendorInfo($vendorId: String!) {
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			isSuperHuemn
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
		}
	}
`;

const getProjects = gql`
	query VendorsProjects($workspaceIds: [String!], $filters: projectsListFiltersInput) {
		vendorsProjects(workspaceIds: $workspaceIds, filters: $filters) {
			data {
				id
				title
			}
		}
	}
`;
const getEventsList = gql`
	query Data($filters: VendorEventsListFiltersInput) {
		vendorEventsList(filters: $filters) {
			data {
				id
				name
				crew {
					count
					role
					managerIds
					subRole
					userIds
				}
				crewNew {
					userId
					roles {
						role
						subRole
					}
					isManager
					isCustomUser
				}
			}
		}
	}
`;

const getTenantUserList = gql`
	query VendorUsers {
		vendorUsers {
			id
			firstName
			lastName
			displayName
		}
	}
`;

const assignEquipmentMutation = gql`
	mutation RootMutation(
		$workspaceId: String!
		$qrCodes: [String!]!
		$assignedTo: LogUserInput!
		$projectId: ID
		$eventId: ID
	) {
		assignEquipment(
			workspaceId: $workspaceId
			qrCodes: $qrCodes
			assignedTo: $assignedTo
			projectId: $projectId
			eventId: $eventId
		) {
			message
		}
	}
`;

class ReAssignEquipments extends ProjectsGraphQl {
	constructor(props) {
		super(props);
		this.state = {
			showDiscardModal: false,
			isAck: false,

			isFileSrcLoading: false,
			isAPISubmitting: false,
			workspacesFilters: [],
			projectsOptions: [],
			eventNameOptions: [],
			crewOptions: [],

			qrCodes: [],
			workspaceId: '',
			projectID: '',
			shootID: '',
			assignedTo: '',
			assignedToUser: '',
		};
	}

	componentDidMount = async () => {
		await this.getVendorsWorkspaces(getVendorInfo, {
			vendorId: this.props.params.vendorID,
		});
		this.getTenantUsers(getTenantUserList);
	};

	isDisabled = () => {
		if (
			_.size(this.state.qrCodes) === 0 ||
			this.state.workspaceId === '' ||
			this.state.projectId === '' ||
			this.state.eventId === '' ||
			this.state.assignedToUser === ''
		) {
			return true;
		} else return false;
	};

	DropdownIndicator = (props) => {
		return (
			<components.DropdownIndicator {...props}>
				<DownIcon />
			</components.DropdownIndicator>
		);
	};

	handleCloseModal = () => {
		this.setState({ showDiscardModal: true });
	};

	handleWorkspaceFilters = (e) => {
		this.setState(
			{
				workspaceId: e.value,
				projectID: '',
				shootID: '',
				assignedTo: '',
			},
			async () => {
				this.setState({
					isProjectsLoading: true,
				});
				await this.getVendorProjects(getProjects, {
					workspaceIds: e.value,
					filters: {
						limit: 1000,
						page: 1,
					},
				});
			},
		);
	};

	handleProjectFilters = (e) => {
		this.setState(
			{
				projectId: e.value,
			},
			async () => {
				this.setState({ isEventsListLoading: true });
				let jsonEventsList = {
					filters: {
						page: 1,
						limit: 10000,
						projectId: e.value,
					},
				};

				await this.getEventsNameList(getEventsList, jsonEventsList, true);
			},
		);
	};

	handleShootFilters = (e) => {
		this.setState({
			eventId: e.value,
		});
		let crewOptions = [];
		_.map(_.filter(this.state.events, { id: e.value })[0].crewNew, (crewArray) => {
			if (crewArray.userId !== null && crewArray.isCustomUser !== true) {
				let user = _.filter(this.state.tenantUserList, {
					id: crewArray.userId,
				})[0];

				crewOptions.push({
					label: user.displayName
						? user.displayName
						: user.firstName + ' ' + user.lastName,
					value: user.id,
				});
			}
		});

		this.setState({ crewOptions });
	};

	handleCrewFilters = (e) => {
		this.setState({
			assignedToUser: e.value,
			assignedTo: {
				id: e.value,
				name: e.label,
			},
		});
	};

	handleSubmitRecordMCBackup = () => {
		let json = {
			qrCode: _.has(this.props, 'qrCode') ? this.props.qrCode : this.state.qrCode,
			workspaceId: this.props.params.workspaceID,
			projectId: this.props.params.projectID,
			eventId: this.props.params.shootID,
		};

		//  this.recordMemoryCardBackup(addNewBackup, json)
	};

	toggleQrCodes = (qrCode) => {
		let index = _.indexOf(this.state.qrCodes, qrCode);
		let qrCodes = this.state.qrCodes;
		if (index >= 0) {
			_.pull(qrCodes, qrCode);
		} else {
			qrCodes.push(qrCode);
		}
		this.setState({ qrCodes });
	};

	handleReAssignEquipments = async () => {
		let json = {
			qrCodes: this.state.qrCodes,
			assignedTo: this.state.assignedTo,
			eventId: this.state.eventId,
			projectId: this.state.projectId,
			workspaceId: this.state.workspaceId,
		};

		let resp = await this.assignEquipment(assignEquipmentMutation, json);

		if (resp[0] == false) {
			toast.error(
				_.has(resp[1], 'message') ? resp[1]['message'] : 'Failed to Assign Equipments',
				{
					position: 'top-right',
					autoClose: 1000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: 'light',
				},
			);
		} else {
			toast.success('Equipment Assigned Successfully!', {
				position: 'top-right',
				autoClose: 500,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: 'light',
			});
			this.props.handleClose();
		}
	};

	renderEquipmentsTable = () => {
		let equipmentsList = _.filter(this.props.equipmentsList, {
			isReceived: false,
		});

		return (
			<div className="mc-events-logs-table-container">
				<table>
					<thead>
						<tr>
							<th>SNo</th>
							<th>description</th>
							<th>Serial ID</th>
							<th>EQ id</th>
							<th>Assigned to</th>
						</tr>
					</thead>
					<tbody>
						{_.size(equipmentsList) > 0 ? (
							_.map(equipmentsList, (equipment, key) => {
								return (
									<div className="hitem column-20w">
										<span onClick={() => this.toggleQrCodes(equipment.qrCode)}>
											{' '}
											<div className={'reAssignTr'}>
												{_.indexOf(this.state.qrCodes, equipment.qrCode) >=
												0 ? (
													<span className="check-icon">
														<CheckedIcon />
													</span>
												) : (
													<span className="empty-check"></span>
												)}
											</div>
										</span>
										<span>
											{_.has(equipment, 'description')
												? equipment.description
												: ''}
										</span>
										<span>
											{_.has(equipment, 'manufacturerId')
												? equipment.manufacturerId
												: ''}
										</span>
										<span>
											{_.has(equipment, 'qrCode')
												? equipment.qrCode
												: 'Unregistered'}
										</span>
										<span>
											{_.has(equipment, 'userId') &&
											_.size(
												_.filter(this.state.tenantUsersList, {
													id: equipment.userId,
												}),
											) > 0
												? _.filter(this.state.tenantUsersList, {
														id: equipment.userId,
												  })[0].firstName +
												  ' ' +
												  _.filter(this.state.tenantUsersList, {
														id: equipment.userId,
												  })[0].lastName
												: ''}
										</span>
									</div>
								);
							})
						) : (
							<tr className="no-items">No Equipments</tr>
						)}
					</tbody>
				</table>
			</div>
		);
	};

	renderFormComponent = () => {
		let backedUpHDD = this.state.backedUpHDD;
		return (
			<div className="mc-record-body-left-right">
				<div className="attachment-preview-text" style={{ marginBottom: '20px' }}>
					Re-assign to Shoot Details
				</div>
				<div className="left-item-container">
					<div className="floating-select-container">
						<label>
							Brand
							<span className="required-star">*</span>
						</label>
						<Select
							className={'cost-select-container zIndex5 w-100p'}
							classNamePrefix="cost-select"
							options={this.state.workspacesFilters}
							onChange={(e) => this.handleWorkspaceFilters(e)}
							defaultValue={
								_.has(this.props, 'qrCode')
									? {
											label: this.props.qrCode,
											value: this.props.qrCode,
									  }
									: null
							}
							components={{
								DropdownIndicator: this.DropdownIndicator,
							}}
							isSearchable={true}
						/>
					</div>
				</div>
				<div className="left-item-container">
					<div className="floating-select-container">
						<label>
							Project
							<span className="required-star">*</span>
						</label>
						<Select
							className={'cost-select-container zIndex4 w-100p'}
							classNamePrefix="cost-select"
							options={this.state.projectsOptions}
							onChange={(e) => this.handleProjectFilters(e)}
							defaultValue={null}
							components={{
								DropdownIndicator: this.DropdownIndicator,
							}}
							isLoading={this.state.isProjectsLoading}
							isSearchable={true}
						/>
					</div>
				</div>
				<div className="left-item-container">
					<div className="floating-select-container">
						<label>
							Shoot
							<span className="required-star">*</span>
						</label>
						<Select
							className={'cost-select-container zIndex3 w-100p'}
							classNamePrefix="cost-select"
							options={this.state.eventNameOptions}
							onChange={(e) => this.handleShootFilters(e)}
							defaultValue={null}
							components={{
								DropdownIndicator: this.DropdownIndicator,
							}}
							isLoading={this.state.isEventsListLoading}
							isSearchable={true}
						/>
					</div>
				</div>
				<div className="left-item-container">
					<div className="floating-select-container">
						<label>
							Assign To
							<span className="required-star">*</span>
						</label>
						<Select
							className={'cost-select-container zIndex2 w-100p'}
							classNamePrefix="cost-select"
							options={this.state.crewOptions}
							onChange={(e) => this.handleCrewFilters(e)}
							defaultValue={null}
							components={{
								DropdownIndicator: this.DropdownIndicator,
							}}
							//isLoading={this.state.isHardDriveLoading}
							isSearchable={true}
						/>
					</div>
				</div>
			</div>
		);
	};

	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'center'}
			>
				<div className="mc-record-center-modal">
					<div className="mc-record-header">
						<span className="header-title">RE ASSIGN EQUIPMENTS</span>
					</div>
					{this.state.isFileSrcLoading ? (
						<LoadingBar />
					) : (
						<>
							<div className="mc-record-body">
								<div
									className="mc-record-body-left-right"
									style={{
										width: '60%',
										borderRight: '1px solid #272727',
									}}
								>
									<div
										className="attachment-preview-text"
										style={{ marginBottom: '20px' }}
									>
										Select Equipments to re-assign
									</div>
									<div
										className="attachment-preview-img"
										style={{
											border: '0px solid #b0b0b0',
										}}
									>
										{this.renderEquipmentsTable()}
									</div>
								</div>
								{this.renderFormComponent()}
							</div>
							<div className="mc-record-tail">
								<div className="button-container">
									<span
										className="cancel-btn"
										onClick={() =>
											this.state.isAPISubmitting === false &&
											this.handleCloseModal()
										}
									>
										Cancel
									</span>
									{this.state.isAPISubmitting === true ? (
										<span className={'confirm-btn active loading-btn'}>
											<LoadingBar />
										</span>
									) : (
										<span
											className={
												'confirm-btn' +
												(this.isDisabled() ? ' ' : ' active')
											}
											onClick={() =>
												this.isDisabled()
													? ''
													: this.handleReAssignEquipments()
											}
										>
											RE-ASSIGN EQUIPMENTS
										</span>
									)}
								</div>
							</div>
						</>
					)}
				</div>
				<Modal
					handleClose={() => this.setState({ showDiscardModal: false })}
					show={this.state.showDiscardModal}
					modalType={'center'}
				>
					<div className="center-confirm-delete-new">
						<div className="delete-modal-header">DISCARD CHANGES</div>
						<div className="middle-delete-container">
							<div className="middle-text">Are you sure?</div>
							<div className="middle-desc">
								If you discard this information, you cannot undo this
							</div>
						</div>
						<div className="bottom-delete-btns">
							<span
								className="cancel-btn"
								onClick={(e) => this.setState({ showDiscardModal: false })}
							>
								No, Cancel
							</span>
							<span
								className="delete-btn"
								onClick={(e) => {
									this.props.handleClose();
									this.setState({ showDiscardModal: false });
								}}
							>
								Yes, Discard
							</span>
						</div>
					</div>
				</Modal>
			</Modal>
		);
	}
}

export default withRouter(ReAssignEquipments);
